import {
  normalizeDataSourceMode,
  fetchTableCatalogCached,
  parsePrimaryQualifiedTable,
  buildTableModeMappingRows,
  buildSqlModeMappingRows,
  filterMappingRowsBySearch,
  columnSelectionFromMappingRows,
} from "@/common/columnMappingCore";

/**
 * Vue 2 helper: build mapping state for column manager / menu-config.
 * @param {object} opts
 */
export async function loadVariableMappingRows(opts) {
  const {
    dataSourceMode,
    datasql = "",
    headerMap = {},
    allHeaderMap = {},
    existingTableRows = [],
    existingSqlRows = [],
    includeShowColumn = false,
    visibleColumns = null,
    showAllCatalogColumns = false,
    aliasedDatasql = "",
  } = opts;

  const mode =
    dataSourceMode === "table" || dataSourceMode === "sql"
      ? dataSourceMode
      : normalizeDataSourceMode({ dataSourceMode });

  if (!mode) {
    return {
      mode: null,
      rows: [],
      catalogError: "Missing or invalid dataSourceMode in vizParamJson",
      schema: "",
      table: "",
    };
  }

  if (mode === "table") {
    const catalog = await fetchTableCatalogCached();
    const qualified = parsePrimaryQualifiedTable(datasql);
    if (!qualified || !qualified.table) {
      return {
        mode,
        rows: [],
        catalogError:
          "Could not parse schema.table from datasql for Table mode.",
        schema: "",
        table: "",
      };
    }
    const schema = qualified.schema || "";
    const table = qualified.table;
    if (schema && catalog[schema] && catalog[schema][table]) {
      const rows = buildTableModeMappingRows({
        catalog,
        schema,
        table,
        datasql,
        headerMap,
        allHeaderMap,
        existingRows: existingTableRows,
        visibleColumns,
        showAllCatalogColumns,
      });
      return { mode, rows, catalogError: null, schema, table };
    }
    const schemas = Object.keys(catalog);
    for (const s of schemas) {
      if (catalog[s] && catalog[s][table]) {
        const rows = buildTableModeMappingRows({
          catalog,
          schema: s,
          table,
          datasql,
          headerMap,
          allHeaderMap,
          existingRows: existingTableRows,
          visibleColumns,
          showAllCatalogColumns,
        });
        return { mode, rows, catalogError: null, schema: s, table };
      }
    }
    return {
      mode,
      rows: [],
      catalogError: `Table ${schema ? schema + "." : ""}${table} not found in catalog.`,
      schema,
      table,
    };
  }

  const rows = buildSqlModeMappingRows({
    datasql,
    headerMap,
    allHeaderMap,
    existingRows: existingSqlRows,
    includeShowColumn,
    visibleColumns,
    aliasedDatasql,
  });
  return {
    mode,
    rows,
    catalogError: rows.length ? null : "Could not parse columns from datasql.",
    schema: "",
    table: "",
  };
}

export function getFilteredMappingRows(rows, searchQuery, mode) {
  return filterMappingRowsBySearch(rows, searchQuery, mode);
}

export function syncSelectionFromMapping(rows, mode, headerMap) {
  return columnSelectionFromMappingRows(rows, mode, headerMap);
}

export { normalizeDataSourceMode };
